"use client";
import { useTranslations } from "next-intl";
import { Skeleton } from "@radix-ui/themes";
import { DataInputParams } from "./inputType";
import { Form, Skeleton as AntSkeleton, Checkbox, Tooltip, Flex } from "antd";
import { checkNoItem, GetDataInputElement, getTooltip } from "./inputFunction";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { Debug } from "@/util/debug";
import { tooltipColor } from "../list/defaultType";
//import { Debug } from "@/util/debug";

const GetInput = (params: DataInputParams) => {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const [value, setValue] = useState<any[] | undefined>(params.fixedValue ?? params.value ?? params.defaultValue);
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setValue"] = (e: any) => {
        params.form?.setFieldValue(params.name, e);
        setValue(e);
      };
      temp_function["setAll"] = (all?: boolean) => {
        if (params.checkboxOption) {
          const vl = value ? value.length : 0;
          if ((all !== undefined && all) || (all === undefined && vl !== params.checkboxOption.length)) {
            const va = params.checkboxOption.map((item) => {
              if (typeof item === "string" || typeof item === "number") {
                return item;
              } else {
                return item.value;
              }
            });
            params.form?.setFieldValue(params.name, va);
            setValue(va);
          } else {
            params.form?.setFieldValue(params.name, []);
            setValue([]);
          }
        }
      };
    }
  }

  useEffect(() => {
    setValue(params.fixedValue ?? params.value ?? params.defaultValue);
  }, [params.fixedValue, params.value, params.defaultValue]);
  const checked =
    params.valueType !== "boolean"
      ? params.defaultValue !== undefined
        ? params.defaultValue === params.value
        : params.value
      : (params.value ?? params.defaultValue);
  if (params.checkboxOption) {
    const checkedProp =
      params.inputMode == "view"
        ? {}
        : {
            id: params.name,
          };
    const checkboxOption = params.checkboxOption.map((item) => {
      return item instanceof Object
        ? { ...item, id: item.id ?? params.name + "_" + item.value }
        : { label: item, value: item, name: params.name, id: params.name + "_" + item };
    });

    //const value = params.inputMode == "view" && !(params.readInputDisabled ?? false) ? params.fixedValue ?? params.value : undefined;
    return (
      <Checkbox.Group
        className={cn(params.inputClassName ?? "m-4", params.readOnly ? "ant-checkbox-readonly" : "")}
        disabled={params.disabled}
        {...checkedProp}
        options={checkboxOption}
        value={value}
        onChange={(e: any) => {
          setValue(e);
          if (params.onChange) {
            //중간에 후킹하는 코드가 있는것 같음. 따라서 추가 파라미터 입력이 불가능함.
            //params.onChange({ key: params.name, value: e, index: params.index });
            params.onChange(e);
          }
        }}
        //defaultValue={params.value ?? params.defaultValue}
      />
    );
  } else {
    const label =
      typeof params.label == "string"
        ? params.transition
          ? t(params.label)
          : params.label
        : params.label
          ? GetDataInputElement(params.label, false, null, t)
          : undefined;

    const value = params.valueType !== "boolean" ? params.defaultValue : undefined;
    const checkedProp =
      params.inputMode == "view"
        ? { checked: checked }
        : {
            id: params.name,
          };
    // Debug("disabled : " + disabled);
    // Debug("checked : " + checked);
    // Debug("defaultChecked : " + params.defaultValue ? params.defaultValue === params.value : params.value);
    return (
      <Checkbox
        className={cn(params.inputClassName ?? "m-4", params.readOnly ? "ant-checkbox-readonly" : "")}
        value={value}
        disabled={params.disabled}
        id={params.name}
        name={params.name}
        {...checkedProp}
        onChange={(e: any) => {
          setValue(e);
          if (params.onChange) {
            //중간에 후킹하는 코드가 있는것 같음. 따라서 추가 파라미터 입력이 불가능함.
            //params.onChange({ key: params.name, value: e, index: params.index });
            params.onChange(e);
          }
        }}
      >
        {label}
      </Checkbox>
    );
  }
};

export default function DataCheckbox(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const [tooltip, setTooltip] = useState(getTooltip(t, params));
  const [disabled, setDisabled] = useState(params.inputMode == "view" && !(params.readInputDisabled ?? false) ? true : params.disabled);

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setTooltip"] = setTooltip;
      temp_function["setDisabled"] = setDisabled;
    }
  }

  useEffect(() => {
    setTooltip(getTooltip(t, params));
  }, [t, params, params.tooltip]);

  useEffect(() => {
    setDisabled(params.inputMode == "view" && !(params.readInputDisabled ?? false) ? true : params.disabled);
  }, [params.inputMode, params.readInputDisabled, params.disabled]);

  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  //const disabled = params.inputMode == "view" && !(params.readInputDisabled ?? false) ? true : params.disabled;
  //const value = params.inputMode == "view" && !(params.readInputDisabled ?? false) ? params.fixedValue ?? params.value : undefined;
  return (
    <Tooltip color={tooltipColor} title={tooltip} placement={params.tooltipPlacement} {...params.tooltipProps}>
      <Flex>
        {prev}
        {unitPrev}
        {checkNoItem(params) ? (
          <GetInput {...params} disabled={disabled} />
        ) : (
          <Form.Item
            id={params.id}
            name={params.name}
            noStyle
            valuePropName="checked"
            initialValue={params.fixedValue ?? params.value ?? params.defaultValue}
            required={params.required}
          >
            <GetInput {...params} disabled={disabled} />
          </Form.Item>
        )}
        {unit}
        {next}
      </Flex>
    </Tooltip>
  );
}
